import React from 'react';
import FingerprintOne from '@grnhse/seedling/lib/birch/illustrations/fingerprint_one';
import { EmptyState } from '@grnhse/seedling/lib/birch/components/empty_state';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';

type NoResultsOverlayProps = {
  hasAnyFilters: boolean;
  onClearAll?: () => void;
  filteredHeader: string;
  filteredBody: string;
  clearButtonLabel: string;
  emptyHeader: string;
  emptyBody?: string;
};

const NoResultsOverlay = ({
  hasAnyFilters,
  onClearAll,
  filteredHeader,
  filteredBody,
  clearButtonLabel,
  emptyHeader,
  emptyBody = '',
}: NoResultsOverlayProps) => {
  return (
    <Stack sx={{ marginTop: 5 }}>
      {hasAnyFilters ? (
        <EmptyState
          header={filteredHeader}
          body={filteredBody}
          Illustration={FingerprintOne}
          size="sm"
        >
          <SecondaryButton onClick={onClearAll}>
            {clearButtonLabel}
          </SecondaryButton>
        </EmptyState>
      ) : (
        <EmptyState
          header={emptyHeader}
          body={emptyBody}
          Illustration={FingerprintOne}
          size="sm"
        />
      )}
    </Stack>
  );
};

export default NoResultsOverlay;
